<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsBar',
  
})
</script>
<template>
  <v-chart
    class="tlbs-bar"
    :option="option"
    :autoresize="true"
  />
</template>

<script lang="ts" setup name="TlbsBar">
import * as echarts from 'echarts/core';
import VChart from 'vue-echarts';
import {
  BarSeriesOption,
} from 'echarts/charts';
import {
  GridComponentOption,
} from 'echarts/components';

type EChartsOption = echarts.ComposeOption<
GridComponentOption | BarSeriesOption
>;

interface valueData {
  name: string;
  data: number[];
}

interface Props {
  data: valueData[];
  color: string[];
  type: 'column' | 'row',
  borderRadius: number | number[],
  barWidth?: number,
  textStyle?: any,
  splitLineStyle?: any,
  seriesProperty?: any,
  xAxis?: LooseObject,
  yAxis?: LooseObject[],
  legend?: LooseObject,
  optionConfig?: LooseObject,
}

const props = withDefaults(defineProps<Props>(), {
  data: () => [],
  color: () => [],
  yAxis: () => [],
  xAxis: () => ({}),
  legend: () => ({}),
  optionConfig: () => ({}),
  seriesProperty: () => ({}),
  type: 'column',
  borderRadius: 0,
  barWidth: 8,
  textStyle: null,
  splitLineStyle: null,
});

const getOption = (): EChartsOption => {
  const option: EChartsOption = {
    color: props.color,
    legend: props.legend,
  };
  let nameArr: never[] | Set<any> = [];
  const categoryArr: string[] = [];
  const valueArr: unknown[][] = [];
  props.data.forEach((data) => {
    categoryArr.push(data.name);
    nameArr = new Set([...nameArr, ...Object.keys(data.value)]);
    Object.values(data.value).forEach((item, index) => {
      valueArr[index] = valueArr[index] || [];
      valueArr[index].push(item);
    });
  });
  // console.log(nameArr);
  // console.log(categoryArr);
  // console.log(valueArr);
  option.series = Array.from(nameArr).map((name, index) => ({
    data: valueArr[index],
    type: 'bar',
    barWidth: props.barWidth,
    ...props.seriesProperty[name] || {},
    name,
  }));
  console.log('series', option.series);
  const labelData = {
    type: 'category',
    data: [...categoryArr],
    axisLabel: {
      textStyle: props.textStyle,
    },
    ...props.xAxis,
  };
  const valueData = props.yAxis.map(item => ({
    type: 'value',
    axisLabel: {
      textStyle: props.textStyle,
    },
    ...item,
  }));
  // console.log('valueData', valueData);
  if (props.type === 'row') {
    option.xAxis = valueData;
    option.yAxis = labelData;
  } else {
    option.xAxis = labelData;
    option.yAxis = valueData;
  }

  if (props.splitLineStyle) {
    option.xAxis.splitLine = {
      lineStyle: props.splitLineStyle,
    };
    option.yAxis.splitLine = {
      lineStyle: props.splitLineStyle,
    };
  }
  console.log(option);
  return { ...option, ...props.optionConfig };
};

const option = ref<EChartsOption>(getOption());

watch(props, () => {
  option.value = getOption();
});


</script>
